import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { SwitchUserRootParamList } from "../../../../types";
import { useActionBackOrClose } from "../../utils/use-action-back-or-close";
import React from "react";
import Staff from "../../../../utilities/data/model/Staff";
import { useDatabase } from "@nozbe/watermelondb/hooks";
import { Q } from "@nozbe/watermelondb";
import {
  Button,
  FlatActionList,
  FlatActionListItem,
  Page,
  View,
} from "@towersystems/roam-common-native";
import { useMeProvider } from "@towersystems/roam-common-native/lib/utilities/authentication";

export type SwitchUserScreenProps = NativeStackScreenProps<
  SwitchUserRootParamList,
  "SwitchUserScreen"
>;

export const SwitchUserScreen = ({ navigation }: SwitchUserScreenProps) => {
  useActionBackOrClose(navigation);

  const database = useDatabase();
  const [staffs, setStaffs] = React.useState<Staff[] | undefined>();
  const { me } = useMeProvider();

  const currentUserOwner = Boolean(
    me.roles.find((i) => i.code === "store-owner"),
  );

  React.useEffect(() => {
    database
      .get<Staff>("staffs")
      .query(
        Q.where("enabled", Q.eq(true)),
        Q.where("has_user_account", Q.eq(true)),
        Q.where("user_id", Q.notEq(me.id)),
      )
      .fetch()
      .then((i) => setStaffs(i));
  }, [me.id]);

  let items: FlatActionListItem[] = [];

  if (false === currentUserOwner) {
    items.push({
      key: "owner",
      title: "Switch to Owner Account",
      onPress: () => {
        navigation.navigate("SwitchUserEnterCredentialsScreen", {});
      },
    });
  }

  items = [
    ...items,
    ...(staffs?.map((staff) => ({
      key: staff.id,
      title: staff.fullName,
      titleContent: ({
        title,
        subTitle,
      }: {
        title: React.ReactNode;
        subTitle: React.ReactNode;
      }) => (
        <View>
          {title}
          {subTitle}
        </View>
      ),
      onPress: () => {
        navigation.navigate("SwitchUserEnterCredentialsScreen", {
          username: staff.username,
        });
      },
    })) || []),
  ];

  const listMarkup = <FlatActionList items={items} />;

  let title = "";
  let description = "";

  if (staffs !== undefined) {
    if (staffs.length === 0) {
      title = "No Staff Accounts Found";
      description =
        "Consider creating individual staff accounts for your team members to log in with their own accounts.";
    } else {
      title = "Select a Staff Member";
      description = "Select a staff member to log in as.";
    }
  }

  return (
    <Page
      title={title}
      secondaryTitle={description}
      titleContainerStyle={{ alignItems: "center" }}
    >
      {listMarkup}
    </Page>
  );
};
